export interface MenuProps {
  label: string;
  to?: string;
  eventName?: string;
  items?: Array<MenuItemProps | undefined>;
}

export interface MenuItemProps {
  label: string;
  to: string;
  eventName: string;
}

export interface ActionButtonProps {
  label: string;
  href: string;
  eventName: string;
  eventParams?: object;
  variant?: "outlined" | "contained";
  marginLeft?: boolean;
}

export const MENUS: MenuProps[] = [
  {
    label: "AI Competition",
    to: "/blog/competition-winner",
    eventName: "click-menu-competition",
  },
  {
    label: "Blog",
    to: "/blog",
    eventName: "click-menu-blog",
  },
  {
    label: "Products",
    items: [
      {
        label: "Iris Assessments",
        to: "/assessment",
        eventName: "click-menu-products-assessment",
      },
      {
        label: "Iris Editor",
        to: "/editor",
        eventName: "click-menu-products-editor",
      },
      {
        label: "Book Business Cards",
        to: "/business-card",
        eventName: "click-menu-products-business-card",
      },
      {
        label: "Pricing",
        to: "/pricing",
        eventName: "click-menu-products-pricing",
      },
    ],
  },
  {
    label: "Learn",
    items: [
      {
        label: "Iris for Authors",
        to: "/authors",
        eventName: "click-menu-products-authors",
      },
      {
        label: "Iris for Publishers",
        to: "/publishers",
        eventName: "click-menu-products-publishers",
      },
      {
        label: "The Iris Engine",
        to: "/iris",
        eventName: "click-menu-documentation-iris",
      },
      {
        label: "Understanding Iris' reports",
        to: "/reports",
        eventName: "click-menu-documentation-reports",
      },
      {
        label: "Quantifiction's use of AI",
        to: "/rai",
        eventName: "click-menu-documentation-rai",
      },
      {
        label: "Frequently asked questions",
        to: "/faq",
        eventName: "click-menu-documentation-faq",
      },
    ],
  },
  {
    label: "About",
    items: [
      {
        label: "Company",
        to: "/company",
        eventName: "click-menu-about-company",
      },
      {
        label: "Team",
        to: "/team",
        eventName: "click-menu-about-team",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Menu.ts